// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: true,
  API: {
    BASE_URL: 'https://hhcwebapi.azurewebsites.net/api',
  },
  fp: 'floorplans', //toggle endpoints: floorplans & scullyfloorplans(removes spaces)
  ordered: 'floorplans', //ordered by Series name if I add /ordered
  faqs: 'faqs',
  blogposts: 'blogposts',
  media: 'Media/GetByMediaId', //see media.service for info on call to GetByMediaId
  location: 'location',
  geocontent: 'geo-content',
  appInsights: {
    instrumentationKey: '6e15a750-72fa-4cc1-af55-c9821c80076d', //key created in portal.azure.com
  },
};

//RESULTS:
//when using 'scullyfloorplans', removes spaces in API for seriesName etc
//e.g. Columbia River is delivered as Columbia-River
//when using 'floorplans', deliver as Columbia River
//prefer to use 'floorplans' so that API is not having to make adjustments for pathnames - USED THIS OPTION

//https://hhcwebapi.azurewebsites.net/api/floorplans
//https://hhcwebapi.azurewebsites.net/api/scullyfloorplans
